/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import {combineReducers} from "redux"
import errorReport from "../error-report/redux/errorReport.reducer"

export default combineReducers({errorReport})
